import React, { useState, useEffect } from "react";
import { FaUserAlt, FaLock } from "react-icons/fa";
import { login } from "../../Api/services/AuthServices";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../NavBar";
import Footer from "../Footer";

const LoginPage = () => {
    const [email, setEmail] = useState("raj@gma21.com");
    const [password, setPassword] = useState("sfdffdasfdfdes");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent form reload
        setError(""); // Clear previous errors

        setLoading(true);
        try {
            const response = await login({ email, password });
            console.log(response);
            if (response.status === 200) {
                localStorage.setItem("token", response.data.token);
                localStorage.setItem("user", JSON.stringify(response.data.user));
                navigate(localStorage.getItem("redirectAfterLogin") || "/");
                localStorage.removeItem("redirectAfterLogin");
            } else {
                setError(response.message || "Login failed");
            }
        } catch (err) {
            console.error(err);
            setError("An error occurred. Please try again.");
        }
        setLoading(false);
    };

    return (
        <>
            <Navbar />
            <div className="flex items-center justify-center min-h-[80vh] bg-gray-100">
                <div className="relative w-full max-w-lg bg-white shadow-lg p-8 rounded-lg">
                    <h1 className="text-2xl font-bold mb-6 text-center">Login</h1>

                    <form onSubmit={handleSubmit} className="w-full p-4">
                        <div className="mb-6">
                            <div className="relative">
                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                                    <FaUserAlt className="text-gray-500" />
                                </span>
                                <input
                                    type="text"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Username"
                                    className="block w-full pl-10 p-3 border border-gray-300 shadow-sm sm:text-sm"
                                />
                            </div>
                        </div>

                        <div className="mb-6">
                            <div className="relative">
                                <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                                    <FaLock className="text-gray-500" />
                                </span>
                                <input
                                    type="password"
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Password"
                                    className="block w-full pl-10 p-3 border border-gray-300 shadow-sm sm:text-sm"
                                />
                            </div>
                        </div>

                        {error && (
                            <div className="mb-4 text-red-500 text-sm">
                                {error}
                            </div>
                        )}

                        <div className="flex items-center mb-6">

                        </div>

                        <button
                            type="submit"
                            className={`w-full bg-black text-white py-3 rounded-md shadow-md hover:bg-gray-900 focus:ring-2 focus:ring-blue-500 focus:outline-none ${loading ? "cursor-not-allowed" : ""}`}
                            disabled={loading}
                        >
                            {loading ? "Loading..." : "LOGIN"}
                        </button>

                        <div className="mt-4 text-center">
                            <span className="text-gray-600">Don't have an account? </span>
                            <Link
                                to="/signup"
                                className="text-blue-500 hover:underline font-medium"
                            >
                                Sign up
                            </Link>
                        </div>

                    </form>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default LoginPage;
